import httpClient from "./httpClient";
import _ from "lodash";

const END_POINT = "/api/matriculas";

const getByCurso = (idCurso) =>
  httpClient.get(`${END_POINT}/intranet`, {
    params: { curso: idCurso, pagination: false },
  });

const getByPrematricula = async (idPrematricula) =>
  await httpClient.get(END_POINT, { params: { prematricula: idPrematricula } });

const getByAlumno = async (idAlumno) =>
  await httpClient.get(END_POINT, { params: { alumno: idAlumno } });

const getCSVData = (idCurso) =>
  httpClient.get(`${END_POINT}/csv`, { params: { curso: idCurso } });

const update = async (item) => {
  let idMatricula = item.id || null;

  if (idMatricula == null) {
    throw new Error("No es posible actualizar la matricula, ID es nulo.");
  }

  const params = {
    observaciones: item.observaciones,
    notaJunio:
      _.isNil(item.notaJunio) || _.isEmpty(item.notaJunio)
        ? null
        : item.notaJunio.id,
    notaSeptiembre:
      _.isNil(item.notaSeptiembre) || _.isEmpty(item.notaSeptiembre)
        ? null
        : item.notaSeptiembre.id,
  };

  return await httpClient.put(`${END_POINT}/${idMatricula}`, { ...params });
};

export { getByCurso, getByPrematricula, getByAlumno, getCSVData, update };
